import $ from 'jquery';
import { discounted } from './discount';

function getPartial(content: string, selector: string): HTMLElement {
  return $('<div>').append($.parseHTML(content)).find(selector)[0];
}

let handlerInstalled = false;
function installPopstateHandler(): void {
  if (handlerInstalled) return;

  handlerInstalled = true;
  $(window).on('popstate', (e) => document.location.reload());
}

const requests: JQuery.jqXHR<unknown>[] = [];

function loadAlbums(url: string, data?: string): void {
  const request = $.ajax({
    url,
    data,
    method: 'get',
    beforeSend(xhr, settings) {
      installPopstateHandler();
      url = settings
        .url!.replace('&skip_filters=true', '')
        .replace('?skip_filters=true', '');
      history.pushState(null, '', url);
    },
  });

  window.gtag({
    event: 'loadAlbumsAjaxCall',
    loadAlbumsAjaxUrl: url,
  });
  requests.push(request);

  request.done(function (content: string) {
    // Regexp based link extraction is used because simply doing something line $(content).find("link") does not work
    // https://stackoverflow.com/questions/6417157/jquery-selector-for-link-elements-in-head
    const links = content.match(/<link[^>]*>/g) || [];

    const canonicalLink = links.find((value) => value.match(/rel=.canonical./));
    $("head link[rel='canonical']").remove();
    if (canonicalLink) {
      $('head').append(canonicalLink);
    }

    const linkRelPrev = links.find((value) => value.match(/rel=.prev./));
    $("head link[rel='prev']").remove();
    if (linkRelPrev) {
      $('head').append(linkRelPrev);
    }

    const linkRelNext = links.find((value) => value.match(/rel=.next./));
    $("head link[rel='next']").remove();
    if (linkRelNext) {
      $('head').append(linkRelNext);
    }

    $('#search-content').html(getPartial(content, '#search-content'));
    $('#current-search-genre').html(
      getPartial(content, '#current-search-genre')
    );
    discounted();
  });
}

const loadSidebar = function (url: string, data: string): void {
  const request = $.ajax({
    url,
    data,
    method: 'get',
  });
  requests.push(request);
  request.done(function (content) {
    $('#search-sidebar').html(getPartial(content, '#search-sidebar'));
    $('#search-genre-modal').html(getPartial(content, '#search-genre-modal'));
    $(document).trigger('turbo:load');
  });
};

$(document).on('submit', '.js-ajax', function (event) {
  event.preventDefault();
  event.stopImmediatePropagation();
  const form = $(this);
  const dataArr = form.serializeArray();
  const uniqDataArr = dataArr.reverse().reduce(function (pv, cv) {
    const names = pv.map((v) => v.name);
    if (names.indexOf(cv.name) < 0 || cv.name.slice(-2) === '[]') {
      pv.push(cv);
    }
    return pv;
  }, [] as JQuery.NameValuePair[]);
  const data = $.param(uniqDataArr.reverse());
  requests.map((e) => e.abort());
  const url = window.location.href.replace(window.location.search, '');
  loadAlbums(url, data + '&skip_filters=true');
  loadSidebar(url, data + '&skip_results=true');
  form.find('.modal-trigger').prop('checked', false);
});

$(document).on('click', '.js-ajax .filterSidebar-actions input', function (e) {
  $('#filterToggle').prop('checked', false);
  $('.l-sidebarList').get(0)?.scrollIntoView();
});

$(document).on('ready turbo:load turbo:frame-load', function () {
  if ($('.filterSidebar.js-dummy').length > 0) {
    loadSidebar(document.location.toString(), 'skip_results=true');
  }
});
